import { clsx } from "clsx";

export function Item({ children, correta, touched, onClick }) {
    const classes = clsx(
        "correcao-tri-item",
        {
            ['correcao-tri-item-correto']: touched && correta,
            ['correcao-tri-item-errado']: touched && !correta,
        },
    );

    function handleClick(e) {
        onClick(e);
    }

    return <li className={classes} onClick={handleClick}>{children}</li>;
}